import { createContext, useContext, type PropsWithChildren } from 'react'

const ExperienceBookmarkHiddenContext = createContext(false)

/**
 * Suppresses experience bookmark ("Save") buttons rendered by shared experience
 * components within this subtree, e.g. the buy bar inside the trip planner
 * experience drawer.
 */
export function ExperienceBookmarkHiddenProvider({ children }: PropsWithChildren) {
  return (
    <ExperienceBookmarkHiddenContext.Provider value>
      {children}
    </ExperienceBookmarkHiddenContext.Provider>
  )
}

export function useIsExperienceBookmarkHidden(): boolean {
  return useContext(ExperienceBookmarkHiddenContext)
}
